<div class="toggle-websearch-controls" (click)="toggleWebSearch()"
        [class.disabled]="componentButtonDisabled"
        [attr.disabled]="componentButtonDisabled"
        [attr.aria-disabled]="componentButtonDisabled">
    <div class="toggle-icon">
        <img [src]="webSearch ? 'assets/icons/web-search/web-search-on.svg' : 'assets/icons/web-search/web-search-off.svg'" alt="Web Search Toggle" width="20" height="21">
        <span [ngClass]="{'active-web-search': webSearch, 'inactive-search': !webSearch}">Search</span>
    </div>
</div>
